// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 966 ? "login" : chunkId) + "." + {"552":"056ecfc9","565":"7be163b2","966":"989bc926"}[chunkId] + ".css";
};